exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirm[data-v-447c67a2]{position:absolute;top:0;left:0;width:100%;height:100%;background-color:var(--background-gray)}.confirm[data-v-447c67a2],.confirm .actions[data-v-447c67a2]{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}.confirm .actions button[data-v-447c67a2]{margin:1em;width:100px;text-align:center}", ""]);

// exports
